import React from 'react';
import { Link } from 'react-router';


class TourTodoItem extends React.Component {
  makeMessage(url, message, pred) {
    if (pred && url) {
      return (
        <Link to={url}>{message}</Link>
      );
    }
    return (<span>{message}</span>);
  }
  render() {
    const checked = this.props.checked;
    const url = this.props.url;
    const message = this.props.message;
    const pred = (this.props.pred === null) ? true : this.props.pred;
    const item = this.makeMessage(url, message, pred);


    if (checked) {
      return (
        <li>
          <input type="checkbox" checked={checked} disabled />
          <del>
            {item}
          </del>
        </li>
      );
    }
    return (
      <li>
        <input type="checkbox" checked={checked} disabled />
        {item}
      </li>
    );
  }
}
export default TourTodoItem;



// WEBPACK FOOTER //
// src/routes/tours/components/TourTodoItem.js